import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";

@Component({
    selector: 'app-competitions',
    templateUrl: './competitions.component.html'
})
export class CompetitionsComponent implements OnInit {

    public slug;

    competition = {};

    galleryOptions = [
        {
            width: '600px',
            height: '400px',
            thumbnailsColumns: 4,
        }
    ];
    categories = [];


    galleryImages = [];
    competition_images = [];

    constructor(public share: ShareButtons, private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.getCompetition();
            this.getCompetitionImages();
        });

        this.getCategories();

    }

    getCategories() {
        this.http.get(Conf.API_URL + '/category-for-competition/?show_all&count=0').subscribe(
            data => {
                this.categories = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getCompetition() {
        this.http.get(Conf.API_URL + '/competition/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.competition = data['results'][0];
                } else {
                    this.router.navigateByUrl('/404');
                    return false;
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }


    getCompetitionImages() {
        this.http.get(Conf.API_URL + '/competition-images/?things_to_do__slug=' + this.slug).subscribe(
            data => {
                this.competition_images = data['results'];

                var this_m = this;

                $.each(this.competition_images, function (index, value) {
                    this_m.galleryImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })

                });

                // console.log(this.galleryImages)
            },
            error => {
                console.log(error.error)
            }
        );
    }


}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/competitions/competitions.component.ts